import { FC } from 'react';

import { Text } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { AdfoxInfoRequiredField } from 'components/Admin/AdfoxInfo/buildAdfoxInfo';

import styles from 'components/Admin/AdfoxInfo/AdfoxInfoResult/AdfoxInfoResult.module.less';

const TrlKeys: Record<AdfoxInfoRequiredField, string> = {
    ctaLabel: 'admin.adfoxInfo.field.ctaLabel',
    advertiserName: 'admin.adfoxInfo.field.advertiserName',
    advertiserInn: 'admin.adfoxInfo.field.advertiserInn',
    erid: 'admin.adfoxInfo.field.erid',
};

interface FieldListProps {
    title: string;
    fields: AdfoxInfoRequiredField[];
    dataQa: string;
}

export const FieldList: FC<FieldListProps> = ({ title, fields, dataQa }) => {
    const trls = useTrls();

    return (
        <div data-qa={dataQa}>
            <Text>{title}</Text>
            <ul className={styles.fieldList}>
                {fields.map((field) => (
                    <li key={field}>
                        <Text>{trls(TrlKeys[field])}</Text>
                    </li>
                ))}
            </ul>
        </div>
    );
};
